module.exports = __webpack_public_path__ + "img/death.2244e47f.jpg";